// Product gallery: thumbnail buttons swap which media fills the main frame.
class ProductGallery extends HTMLElement {
  #ac = null;
  #active = 0;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener(
      'command',
      (event) => {
        if (event.command !== '--show') return;
        const index = Number(event.source?.dataset.index);
        if (Number.isInteger(index)) this.show(index);
      },
      { signal: this.#ac.signal },
    );
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  async show(index) {
    if (index === this.#active) return;
    const slides = this.querySelectorAll('[data-gallery-slide]');
    const incoming = slides[index];
    const outgoing = slides[this.#active];
    if (!incoming) return;

    this.#active = index;
    for (const button of this.querySelectorAll('[data-gallery-thumb]')) {
      button.setAttribute('aria-pressed', String(Number(button.dataset.index) === index));
    }

    incoming.hidden = false;
    incoming.removeAttribute('inert');
    incoming.removeAttribute('aria-hidden');

    if (!outgoing) return;
    for (const video of outgoing.querySelectorAll('video')) video.pause();
    outgoing.setAttribute('inert', '');
    outgoing.setAttribute('aria-hidden', 'true');

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduceMotion) {
      outgoing.style.zIndex = '1';
      await outgoing.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 180,
        easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
      }).finished;
      outgoing.style.zIndex = '';
    }
    // A newer selection may have re-activated this slide mid-fade.
    if (slides[this.#active] !== outgoing) outgoing.hidden = true;
  }
}

customElements.define('s-product-gallery', ProductGallery);
